import { api } from "../../lib/api";
import { PageLoading, ErrorState } from "../../components/States";
import { fmtDateTime } from "../../lib/format";
import { useAdminData, act, FilterSelect, Pager } from "./shared";

export default function AdminReports() {
  const { data, error, page, setPage, filters, setFilters, reload } = useAdminData(api.adminReports, { status: "open" });
  const rows = data?.items || [];

  return (
    <div data-testid="admin-reports-page">
      <div className="flex flex-wrap gap-3 mb-4">
        <FilterSelect value={filters.status || "open"} onChange={(v) => setFilters((f) => ({ ...f, status: v }))} label="Report status" testid="admin-reports-status"
                      options={[["open", "Open"], ["resolved", "Resolved"], ["all", "All"]]} />
      </div>
      {error ? <ErrorState body={error} onRetry={reload} /> : !data ? <PageLoading label="Loading reports…" /> : rows.length === 0 ? (
        <p className="text-sm text-zinc-500" data-testid="admin-reports-empty">No {filters.status === "all" ? "" : filters.status} reports.</p>
      ) : (
        <>
          <div className="space-y-4" data-testid="admin-reports-table">
            {rows.map((r) => (
              <div key={r.report_id} className="card-dark p-5" data-testid={`report-item-${r.report_id}`}>
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="min-w-0">
                    <p className="font-semibold text-sm">Unauthorized-listing report · <span className="text-zinc-400 capitalize">{r.reporter_type}</span> · <StatusBadgeInline value={r.status} /></p>
                    <p className="text-xs text-zinc-500 mt-1">Listing {r.spot_id} · {fmtDateTime(r.created_at)}{r.contact_email ? ` · contact: ${r.contact_email}` : ""}</p>
                    <p className="text-sm text-zinc-300 mt-2 whitespace-pre-line">{r.details}</p>
                  </div>
                  {r.status === "open" && (
                    <div className="flex gap-2">
                      <button data-testid={`report-dismiss-${r.report_id}`} onClick={() => act(() => api.adminResolveReport(r.report_id, { resolution: "dismissed" }), "Dismissed — listing reactivated", reload)}
                              className="text-xs font-semibold px-3 py-1.5 rounded-full border border-emerald-700 text-emerald-400 hover:bg-emerald-950 transition-colors">Dismiss</button>
                      <button data-testid={`report-uphold-${r.report_id}`} onClick={() => { const n = window.prompt("Resolution note (optional):"); if (n !== null) act(() => api.adminResolveReport(r.report_id, { resolution: "upheld", note: n }), "Upheld — listing suspended", reload); }}
                              className="text-xs font-semibold px-3 py-1.5 rounded-full border border-[#27272A] text-[#FF3B45] hover:border-[#FF3B45] transition-colors">Uphold &amp; suspend</button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <Pager page={page} total={data.total} pageSize={data.page_size} onPage={setPage} testid="admin-reports-pager" />
        </>
      )}
    </div>
  );
}

const StatusBadgeInline = ({ value }) => (
  <span className={`text-[11px] font-semibold ${value === "open" ? "text-amber-400" : "text-emerald-400"}`}>{value}</span>
);
